import type { ReactNode } from 'react';
import { cn } from './cn';

export type Ton = 'succes' | 'attention' | 'danger' | 'info' | 'neutre' | 'marque';

const tons: Record<Ton, string> = {
  succes: 'text-success bg-success-bg border-success-border',
  attention: 'text-warning bg-warning-bg border-warning-border',
  danger: 'text-danger bg-danger-bg border-danger-border',
  info: 'text-info bg-info-bg border-info-border',
  neutre: 'text-neutral bg-neutral-bg border-neutral-border',
  marque: 'text-primary bg-primary-subtle border-primary-border',
};

/** Un statut n'est jamais un aplat : toujours le trio couleur, fond, bordure. */
export function Badge({
  ton = 'neutre',
  point = false,
  children,
  className,
}: {
  ton?: Ton;
  point?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        point && 'before:size-1.5 before:rounded-full before:bg-current',
        tons[ton],
        className
      )}
    >
      {children}
    </span>
  );
}
